import {vueVersion} from "./VueVersion";
import {i18n} from "@/main";
import {toast} from "./Notification";


/*
* function receive 5 params
* last param use for color of toast
* (rawText, rawTextTitle) param use in vue2 to show toast only dashboard :|
* (translatedTextPath, translatedTextTitlePath) params get path of the text from text of the i18n translation
*
*/
export const toastTranslationHelper = (rawText, translatedTextPath, params = {}, toastType = 'success') => {
    if (vueVersion() == 2) {
        toast(rawText, rawText, 'danger');
    } else {
        let originaltranslateValue = i18n.global.t(translatedTextPath,params);
        toast(originaltranslateValue, originaltranslateValue, toastType);
    }
}